module.exports = __webpack_public_path__ + "chevron-wr.1ac2bae5.png";


//////////////////
// WEBPACK FOOTER
// ./client/components/chevron-wr.png
// module id = 478
// module chunks = 0